var _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRightCircle(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5049 23.1494L33.7799 23.8744L23.6305 13.725L24.3554 13L34.5049 23.1494Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7799 22.4289L34.5049 23.1538L24.3554 33.3033L23.6305 32.5783L33.7799 22.4289Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9999 22.7399L33.4796 22.7399L33.4796 23.7651L13.9999 23.7651L13.9999 22.7399Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightCircle);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iNDciIHZpZXdCb3g9IjAgMCA0NyA0NyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSIyMy41IiBjeT0iMjMuNSIgcj0iMjMiIHN0cm9rZT0iY3VycmVudENvbG9yIi8+PHBhdGggZD0iTTM0LjUwNDkgMjMuMTQ5NEwzMy43Nzk5IDIzLjg3NDRMMjMuNjMwNSAxMy43MjVMMjQuMzU1NCAxM0wzNC41MDQ5IDIzLjE0OTRaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48cGF0aCBkPSJNMzMuNzc5OSAyMi40Mjg5TDM0LjUwNDkgMjMuMTUzOEwyNC4zNTU0IDMzLjMwMzNMMjMuNjMwNSAzMi41NzgzTDMzLjc3OTkgMjIuNDI4OVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTMuOTk5OSAyMi43Mzk5TDMzLjQ3OTYgMjIuNzM5OUwzMy40Nzk2IDIzLjc2NTFMMTMuOTk5OSAyMy43NjUxTDEzLjk5OTkgMjIuNzM5OVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";
export { ForwardRef as ReactComponent };